import { StyleSheet, Platform } from 'react-native';

import { Fonts, Metrics, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  itemContainerStyle: theme => ({
    flex: 1,
    flexDirection: 'row',
    borderTopWidth: 1,
    borderColor: Colors.border,
    justifyContent: 'space-between',
    paddingHorizontal: Metrics.doubleBaseMargin,
    paddingVertical: Metrics.baseMargin,
    alignItems: 'center',
    backgroundColor: theme.colors.backgroundColor
  }),
  itemImageTextContainerStyle: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  imageStyle: {
    width: 30,
    height: 30,
  },
  itemTextStyle: theme => ({
    color: theme.colors.headerTitleColor,
    marginHorizontal: 15,
    fontSize: Fonts.size.regularSmall,
    marginTop: Platform.OS === 'ios' ? 5 : -1,
  }),
});
